module.exports = __webpack_public_path__ + "static/media/cockroach(4).ae8abe48.PNG";